import { DateTime } from "luxon"

//PrimeReact
import { useField } from "formik"
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"

//Housing components and assets
import myStyle from "../../../styles/housing/HousingManagementForm.module.css"

export default function Bed({ index, disabled, roomBedCounter, refresh }) {
  const [, , removalHelper] = useField(`beds[${index}].removalDate`)
  const [allocatedField] = useField(`beds[${index}].isAllocated`)

  const confirmRemoval = () => {
    confirmDialog({
      message: (
        <>
          Do you want to remove this bed?{" "}
          {!!allocatedField.value ? (
            <>
              <br /> <br />
              Note: The participant allocated to this bed will automatically be
              unallocated.
            </>
          ) : null}
        </>
      ),
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        removalHelper.setValue(DateTime.now().toUTC().toISO())
        refresh()
      },
    })
  }

  const GetBadge = () => {
    return (
      <div
        className={
          !!allocatedField.value
            ? myStyle.allocatedBadge
            : myStyle.unallocatedBadge
        }
      >
        {!!allocatedField.value ? "occupied" : "available"}
      </div>
    )
  }

  return (
    <>
      <ConfirmDialog />
      <div className={myStyle.roomBedLabel}>
        <span className={`material-icons`}>{"bed"}</span>
        <label>#{roomBedCounter} Name</label>
        <GetBadge />
      </div>
      <div className={myStyle.roomBedInput}>
        <div className={myStyle.roomBedTextInput}>
          <FormikTextInput
            name={`beds[${index}].name`}
            label=""
            disabled={disabled}
          />
        </div>

        <button
          type="button"
          className={`btn t-tip ${myStyle.roomHeaderButton}`}
          onClick={(e) => {
            confirmRemoval()
          }}
          disabled={disabled}
        >
          <span className={`material-icons`}>{"delete"}</span>
        </button>
      </div>
    </>
  )
}
